<template>
  <v-dialog v-model="value" max-width="800" :dark="dark" persistent>
    <v-card :color="color">
      <v-card-title style="word-break: normal">
        {{ title }}
      </v-card-title>
      <v-card-text class="text-subtitle-1 ">
        {{ text }}
      </v-card-text>
      <v-card-text>
        <Button title="i-am-legal" @click="close" />
        <Button title="i-am-not-legal" sub-button :href="link" :dark-override="dark" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/dialogs/DialogMixin';
import Button from '@/components/Button';

export default {
  name: 'AreYouLegal',
  components: { Button },
  mixins: [DialogMixin],
  computed: {
    text() {
      return this.$store.state.data.settings.alert_alco_text
        || this.$dictionary.get('are-you-legal-text');
    },
    title() {
      return this.$store.state.data.settings.alert_alco_title
        || this.$dictionary.get('are-you-legal-title');
    },
    link() {
      return this.$store.state.data.settings.alert_alco_link
        || 'http://google.com';
    },
  }
};
</script>
